import { GridItem, Stack } from '@chakra-ui/react';
import { ListRow } from 'components/molecules/ListRow';
import { TextWithTooltip } from 'components/molecules/TextWithTooltip/TextWithTooltip';
import { FC } from 'react';
import { ReleaseComponent } from 'types/releaseComponent';

type Props = {
  /** リリースコンポーネント */
  item: ReleaseComponent;
  /** 行クリックイベントのハンドラ */
  handleClickRow: () => void;
};

export const ComponentListItem: FC<Props> = ({ item, handleClickRow }) => (
  <ListRow
    onClick={handleClickRow}
    templateColumns="minmax(0, 1fr) minmax(0, 2fr) minmax(0, 2fr) minmax(0, 3fr)"
  >
    <GridItem w="100%">
      <TextWithTooltip
        text={item.componentName}
        visibleTooltip
        tooltipMaxWidth="150px"
      />
    </GridItem>
    <GridItem w="100%">
      <TextWithTooltip
        text={item.repositoryUrl}
        visibleTooltip
        tooltipMaxWidth="300px"
      />
    </GridItem>
    <GridItem w="100%">
      <TextWithTooltip
        text={item.manifestName}
        visibleTooltip
        tooltipMaxWidth="300px"
      />
    </GridItem>
    <GridItem w="100%">
      {item.targetKeys?.map((targetkey, index) => (
        <Stack key={index.toString()}>
          <TextWithTooltip
            text={targetkey.value}
            visibleTooltip
            tooltipMaxWidth="600px"
          />
        </Stack>
      ))}
    </GridItem>
  </ListRow>
);
